import { About } from '../constants/actionTypes'
const { TOGGLE_ABOUT } = About
export const toggleAbout = payload => ({
  type: TOGGLE_ABOUT,
  payload,
})
